import React from 'react'
import { makeStyles } from '@material-ui/core'
import ProfilePicture from './ProfilePicture'
import HeaderInfo from './HeaderInfo'

const useStyles = makeStyles((theme) => ({
  clientDetailsHeader: {
    display: 'flex',
    flexDirection: 'row',
    gap: '50px',
    marginBottom: '15px'
  }
}))

function ClientDetailsHeader () {
  const classes = useStyles()

  return (
    <header className={classes.clientDetailsHeader}>
      <ProfilePicture />
      <HeaderInfo />
    </header>
  )
}

export default ClientDetailsHeader
